export default function postMessageToWindow(data) {
  /**
   * Sends a postMessage to the site hosting this form in an iframe
   * @param data {Object} The data to post to the parent
   */
  window.parent.postMessage(data, '*');
}
